/* RESPONSIBLE TEAM: team-proactive-support */
import Model, { attr } from '@ember-data/model';

export default class DedicatedIp extends Model {
  @attr('string') appId;
  @attr('string') ipAddress;
  @attr('boolean') autoWarmupEnabled;
  @attr('number') autoWarmupStage;
}
